import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, CustomerCartInput, FetchCustomerCartIdDeps } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/cartId',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<CustomerCartInput>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchCustomerCartId ({ guestCartId }: FetchCustomerCartIdDeps = {}): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.createCustomerCart({ guestCartId })
      const { data } = response || {}
      const { createCustomerCart } = data || {}
      const { cart_id: cartId } = createCustomerCart || {}

      if (cartId) {
        dispatch(success(cartId))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
